import { Flex } from '@chakra-ui/core'
import { AnimatePresence } from 'framer-motion'
import * as React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useAppContext } from '../../../context/AppProvider'
import { Text } from '../../../typography'
import { MenuItem, Tooltip } from './styles'

type SideBarItemProps = {
  title: string
  to: string
  color: string
  hoverColor: string
  accentColor: string
  icon: React.ReactNode
}

const SideBarItem: React.FC<SideBarItemProps> = ({
  accentColor,
  color,
  hoverColor,
  icon,
  title,
  to
}) => {
  const { drawerOpen } = useAppContext()

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 40em)' })

  const variants = {
    open: {
      x: 0,
      transition: {
        x: { stiffness: 200, velocity: -100 }
      }
    },
    closed: {
      x: isTabletOrMobile ? -50 : 0,
      transition: {
        x: { stiffness: 200 }
      }
    }
  }

  return (
    <MenuItem
      to={to}
      color={color}
      bg={accentColor}
      variants={variants}
      hovercolor={hoverColor}
      activeClassName="active-nav-link"
    >
      <Flex height="50px" width="100%" alignItems="center" className="sidebar-nav-item-wrapper">
        <Flex className="icon-wrap">{icon}</Flex>
        <AnimatePresence>
          {drawerOpen && (
            <Text
              ml={4}
              color={color}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              fontSize=".8rem"
              exit={{ opacity: 0, pointerEvents: 'none' }}
            >
              {title}
            </Text>
          )}
        </AnimatePresence>
        {!drawerOpen && !isTabletOrMobile && (
          <Tooltip bg="green.500" className="sidebar-tooltip">
            <Text fontSize={13}>{title}</Text>
          </Tooltip>
        )}
      </Flex>
    </MenuItem>
  )
}

export default SideBarItem
